"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.liveStatusMapper = void 0;
var enum_mapper_1 = require("../../utils/enum-mapper");
var globalTypes_1 = require("../generated/globalTypes");
var item_type_1 = require("@wix/wix-vod-constants/dist/api-types/enums/item-type");
exports.liveStatusMapper = new enum_mapper_1.EnumMapper((_a = {},
    _a[globalTypes_1.LiveStatus.DVR_PROCESSING] = item_type_1.ItemType.ItemLiveFinalize,
    _a[globalTypes_1.LiveStatus.SCHEDULED] = item_type_1.ItemType.ItemScheduled,
    _a[globalTypes_1.LiveStatus.STREAMING] = item_type_1.ItemType.ItemLive,
    _a[globalTypes_1.LiveStatus.FINISHED] = item_type_1.ItemType.ItemLiveFinalize,
    _a[globalTypes_1.LiveStatus.EXPIRED] = item_type_1.ItemType.ItemLiveFinalize,
    _a[globalTypes_1.LiveStatus.PENDING] = item_type_1.ItemType.ItemLive,
    _a[globalTypes_1.LiveStatus.RECONNECTING] = item_type_1.ItemType.ItemLive,
    _a));
//# sourceMappingURL=live-status.js.map